export const SUN_COLORS = {
  primary: '#FFD700',
  secondary: '#FFA500',
  glow: 'rgba(255, 215, 0, 0.5)'
};

export const MOON_COLORS = {
  primary: '#E6E6FA',
  secondary: '#B8B8FF',
  glow: 'rgba(230, 230, 250, 0.3)'
};

export const COLORS = {
  // Colores base
  white: '#ffffff',
  gold: '#D4AF37',      // dorado clásico
  goldLight: '#FFD700', // dorado brillante
  goldDark: '#C5A028',  // dorado oscuro
  champagne: '#F7E7CE', // champagne claro
  sand: '#E6D5AC',      // arena dorada
  beige: '#F5E6CC',     // beige suave
  ivory: '#FFFFF0',     // marfil cálido
  wheat: '#F5DEB3',     // trigo dorado
  pearl: '#EAE0C8',     // perla dorada
  cream: '#FFEFD5',     // crema melocotón

  // Estilos de botones
  button: {
    primary: {
      bg: '#D4AF37',
      hover: '#C5A028',
      border: '#FFD700',
      hoverBorder: '#D4AF37',
      text: '#ffffff',
      shadow: 'rgba(212, 175, 55, 0.3)',
      innerShadow: 'inset 0 2px 4px 0 rgba(255, 255, 255, 0.3)'
    }
  }
};

// Clase común para botones dorados
export const GOLDEN_BUTTON_CLASS = `
  bg-[${COLORS.button.primary.bg}] 
  text-white 
  rounded-full 
  hover:bg-[${COLORS.button.primary.hover}] 
  transition-all 
  duration-300 
  shadow-md 
  border-2 
  border-[${COLORS.button.primary.border}] 
  hover:border-[${COLORS.button.primary.hoverBorder}]
  hover:shadow-lg
  active:shadow-inner
  style="box-shadow: ${COLORS.button.primary.innerShadow}"
`; 